//////////////////////////////////////////////
//
// Scroll Jump method
// usage: add scroll-jump class to anchor tag
// to jump to an ID tage
//
//////////////////////////////////////////////

// Scroll Jump
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.scroll-jump')
  if (links != null) {
    const speed = 1000
    links.forEach((each) => (each.onclick = scrollAnchors))

    function scrollAnchors(e, respond = null) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top)
      e.preventDefault()
      var targetID = respond ? respond.getAttribute('href') : this.getAttribute('href')
      const targetAnchor = document.querySelector(targetID)
      if (!targetAnchor) return
      const originalTop = distanceToTop(targetAnchor)
      window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' })
      const checkIfDone = setInterval(function () {
        const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = '-1'
          targetAnchor.focus()
          window.history.pushState('', '', targetID)
          clearInterval(checkIfDone)
        }
      }, speed)
    }
  }
})
